<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Update Merchandise Sizes</div>
    </div>
    <div class="white-wrapper" style="zoom: 0.9">
      <form class="row">
        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="size_name"
                type="text"
                name="size_name"
                id="size_name"
              />
              <label>Size Name</label>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="size_short_name"
                type="text"
                name="size_short_name"
                id="size_short_name"
              />
              <label>Alt. Name</label>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="size_is_active"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="merchandise-sizes"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      size_name: "",
      size_id: null,
      size_short_name: "",
      size_description: "",
      size_is_active: "Y",
      submitted: false,
    };
  },
  mounted() {},
  beforeMount() {
    const { size_id } = this.$route.query;
    if (size_id) {
      this.size_id = size_id;
      this.getItemsDetails(size_id);
    }
  },
  methods: {
    getItemsDetails(item_id) {
      let loader = this.$loading.show();
      let payload = {
        size_id: size_id,
      };
      MasterService.GetSingleMerchandiseSizes(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            const {
              size_name,
              size_id,
              size_short_name,
              size_description,
              size_is_active,
            } = data.Records[0];
            this.size_name = size_name;
            this.size_short_name = size_short_name;
            this.size_description = size_description;
            this.size_id = size_id;
            this.size_is_active = size_is_active;
          } else {
            this.$toasted.show(data.message || "Unable to fetch data");
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      if (!this.size_name) {
        return this.$toasted.show("Please Enter Size Name");
      } else if (!this.size_short_name) {
        return this.$toasted.show("Please Enter Short Name");
      } else {
        let loader = this.$loading.show();
        let payload = {
          size_id: this.size_id,
          size_name: this.size_name,
          size_short_name: this.size_short_name,
          size_description: this.size_description,
          size_is_active: this.size_is_active || "Y",
        };
        MasterService.UpdateMerchandiseSizes(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              this.resetForm();
              if (redirect) {
                this.$router.push({
                  path: "merchandise-sizes",
                });
              }
              this.submitted = false;
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    resetForm: function () {
      this.size_id = null;
      this.size_name = "";
      this.size_short_name = "";
      this.size_description = "";
      this.size_is_active = "Y";
      this.btenable = false;
      this.submitted = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MechandiseComponents/UpdateMerchandiseSizes.vue